'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import UINumberInput from 'UIComponents/input/UINumberInput';
import UIStepperInput from 'UIComponents/input/UIStepperInput';
export default class NumberInput extends Component {
  constructor(...args) {
    super(...args);

    this.onChange = ({
      target: {
        value
      }
    }) => {
      return this.props.onChange(value);
    };
  }

  render() {
    const {
      autoFocus,
      disabled,
      id,
      increment,
      max,
      min,
      placeholder,
      readOnly,
      value
    } = this.props;
    const inputProps = {
      autoFocus,
      disabled,
      id,
      max,
      min,
      onChange: this.onChange,
      placeholder,
      readOnly,
      value
    };

    if (increment) {
      return /*#__PURE__*/_jsx(UIStepperInput, Object.assign({}, inputProps, {
        stepSize: increment
      }));
    }

    return /*#__PURE__*/_jsx(UINumberInput, Object.assign({}, inputProps));
  }

}
NumberInput.propTypes = {
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  format: PropTypes.string,
  id: PropTypes.string,
  increment: PropTypes.number,
  max: PropTypes.number,
  min: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};